import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button } from 'react-bootstrap';
import * as AppConstants from '../AppConstants';
import {
  dispatchSessionExpiry,
  dispatchSessionExpand,
  stoptUsrInactivityTimeOut,
  startUsrInactivityTimeOut,
} from '../store/Actions/SharedAction';
import * as commonServiceEndPoint from '../services/service';
import { PaperComponent } from '../utilities/utilities';

const origTitle = document.title;
let animatedTitle;
let timer;
let timeout;
let currentState = false;
const link = document.querySelector("link[rel~='icon']");

export default function SessionExpire() {
  const showSessionExpiryDialog = useSelector(
    (state) => state?.sharedState?.SharedReducer?.showSessionExpiryDialog
  );
  const sessionExtendStatus = useSelector(
    (state) => state?.sharedState?.SharedReducer?.sessionExtendStatus
  );
  // const userInOutStatus = useSelector(
  //   (state) => state?.sharedState?.SharedReducer?.userInOutStatus
  // );
  const keycloakValue = useSelector(
    (state) => state?.sharedState?.SharedReducer?.keycloakObj
  );
  const dispatch = useDispatch();
  const [prompt, setPrompt] = React.useState(false);
  const animateTitle = (newTitle) => {
    animatedTitle = newTitle;
    timer && clearInterval(timer);
    timer = setInterval(
      startAnimation,
      eval(commonServiceEndPoint.TITLE_CHANGE_TIME)
    );
    link.href = '/public/favicon-notify.ico';
  };
  const startAnimation = () => {
    document.title = currentState ? origTitle : animatedTitle;
    currentState = !currentState;
  };

  const restoreTitle = () => {
    dispatch(dispatchSessionExpand(false));
    dispatch(dispatchSessionExpiry(false));
    clearInterval(timer);
    clearTimeout(timeout);
    document.title = origTitle;
    link.href = '/public/favicon.ico';
    setPrompt(false);
  };
  const timedOut = () => {
    restoreTitle();
    keycloakValue.logout();
  };
  const onConfirm = () => {
    dispatch(dispatchSessionExpand(true));
  };
  const onCancel = () => {
    timedOut();
  };

  /* useEffect(() => {
    if (showSessionExpiryDialog) {
      setPrompt(true);
      animateTitle(AppConstants.ANIMATE_TITLE);
      timeout = setTimeout(() => {
        setPrompt(false);
        timedOut();
      }, eval(process.env.REACT_APP_IDLE_TIME));
    }
  }, [showSessionExpiryDialog]); */

  useEffect(() => {
    if (sessionExtendStatus) {
      restoreTitle();
    }
  }, [sessionExtendStatus]);

  // useEffect(() => {
  //   if (userInOutStatus === 'IN') {
  //     stoptUsrInactivityTimeOut();
  //   } else if (userInOutStatus === 'OUT') {
  //     startUsrInactivityTimeOut();
  //   }
  // }, [userInOutStatus]);

  return (
    <Dialog
      open={prompt}
      aria-describedby="alert-dialog-description"
      className="custom-alert-box"
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <div style={{ cursor: 'move' }} id="draggable-dialog-title">
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {AppConstants.SESSION_EXPIRY_MSG}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              onConfirm();
            }}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setPrompt(false);
              onCancel();
            }}
            color="primary"
          >
            No
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
}
